import Dialog from '@mui/material/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeDialog,
  selectABSDialogOptions,
  selectABSDialogState,
} from 'app/store/abs/dialogSlice';

function ABSDialog(props) {
  const dispatch = useDispatch();
  const state = useSelector(selectABSDialogState);
  const options = useSelector(selectABSDialogOptions);

  return (
    <Dialog
      open={state}
      onClose={(ev) => dispatch(closeDialog())}
      aria-labelledby="abs-dialog-title"
      classes={{
        paper: 'rounded-8',
      }}
      {...options}
    />
  );
}

export default ABSDialog;
